export default __webpack_public_path__ + "static/media/streamline-icon-download-bottom@14x14.411837d7.svg";